module.exports = __webpack_public_path__ + "static/media/legend_rainfallYear.35b83030.png";